module.exports = __webpack_public_path__ + "media/images/real-last-2-f0bde45bb9a651511b780531a04e54ed.png";